export const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g clipPath="url(#clip0_5964_52715)">
        <path
          d="M12.3761 24.7521C19.2112 24.7521 24.7521 19.2112 24.7521 12.3761C24.7521 5.54096 19.2112 0 12.3761 0C5.54096 0 0 5.54096 0 12.3761C0 19.2112 5.54096 24.7521 12.3761 24.7521Z"
          fill="#AA2C23"
        />
        <path
          d="M13.8398 6.38281L13.5636 14.8455H11.5547L11.2701 6.38281H13.8398ZM11.2031 17.4654C11.2031 17.1082 11.3259 16.8125 11.5714 16.5781C11.8226 16.3382 12.1518 16.2182 12.5591 16.2182C12.9721 16.2182 13.3013 16.3382 13.5468 16.5781C13.7924 16.8125 13.9152 17.1082 13.9152 17.4654C13.9152 17.8114 13.7924 18.1044 13.5468 18.3443C13.3013 18.5842 12.9721 18.7042 12.5591 18.7042C12.1518 18.7042 11.8226 18.5842 11.5714 18.3443C11.3259 18.1044 11.2031 17.8114 11.2031 17.4654Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5964_52715">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
